<template>

<div style="background-color:white; padding:20px; border:solid 1px #f2f2f2">
    <Row>
        <Col :xs="14" :sm="24" :md="24" :lg="24">
            <router-link :to="productUrl" :aria-label="GeneratedName"> 
                <div v-bind:class="mainContainerClass"> 
                    <div :style="style"  style="height:0; padding-bottom:133%" class="product-image">
                        <div v-if="LazyLoadImage">
                            <img :alt="GeneratedName" :src="imageUrl(Item.Image)" v-bind:class="mainImageClass" @load="loadMain" />
                        </div>
                        <div v-else>
                            <img :alt="GeneratedName" :src="imageUrl(Item.Image)" />
                        </div>
                    </div>
                </div>
            </router-link>
        </Col>
        <Col :xs="10" :sm="24" :md="24" :lg="24">
            <!--<img :src="peekUrl(Item.Image)"  v-bind:class="peekClass" @load="loadPeek" @click="TogglePeek()"  />-->
            <p style="font-size:1.25em; margin-top:10px;"><strong>{{GeneratedName}}</strong></p>
            <p>StyleCode:  {{Item.StyleCode}}</p>
            <p>Primary Color:  {{Item.PrimaryColor.Name}}</p>
            <p>Primary Fabric: {{Item.PrimaryFabric.Name}}</p>
            <p><Price Name="Wholesale: " :Value="wholesale" /></p>
        </Col>
    </Row>
</div>

</template>



<script>
import Price from './Shared/Price';

export default {
	name: 'SingleProduct',
    components: { Price },
    computed: {
        colorSwatchStyle() {
            return  'width:30px; height:30px; display:inline-block; border-radius:50%; position:relative; border:solid 1px #eee; top:-30px; background-color:#' + this.Item.PrimaryColor.HexColor;
        },
        GeneratedName () {
            if (this.Item.Line.Code == 'dm' || this.Item.Line.Code == 'dc' ||
                this.Item.Line.Code == 'as' || this.Item.Line.Code == 'fl' ||
                this.Item.Line.Code == 'lr' || this.Item.Line.Code == 'tb' ||
                this.Item.Line.Code == '15' || this.Item.Line.Code == 'jp' ||
                this.Item.Line.Code == 'ds' || this.Item.Line.Code == 'bb' ||
                this.Item.Line.Code == 'sd' || this.Item.Line.Code == 'jy' ||
                this.Item.Line.Code == '5g')
                {
                    return this.Item.Line.Name + ' Style ' + this.Item.StyleCode
                }
                else 
                {
                    return this.Item.Name
                }
        },      
        wholesale() {
            return Math.round(this.Item.WholesalePrice);
        },
        style() {
            return 'background-color:#' + this.Item.PrimaryColor.HexColor;
        },
        productUrl() {
            return '/product/' + this.Item.ProductId + '?stylecode=' + this.Item.StyleCode + '&pcid=' + this.Item.PrimaryColor.Id;
        },
        mainContainerClass() {
            return (!this.isMainLoaded ?'clipCircle' : '');
        },
        mainImageClass() {
            return  (!this.isMainLoaded ? 'hide' : '');
        },
        peekClass() {
            return 'peek-circle ' + (!this.isPeekLoaded ? 'invisible' : '') + ' ' + (this.peekZoom ? 'active': '');
        }        
    },
    watch: {
        Item(i) {
            if (this.ActiveProductId != this.Item.ProductId) {
                this.ActiveProductId = this.Item.ProductId;
                this.isMainLoaded = false;
                this.isPeekLoaded = false;
            }
            //console.log('lchange')
        }
    },
	props: {
        Item: Object,
        LazyLoadImage: { default: true, type:Boolean}
    },
    methods: {
        TogglePeek() {
            this.peekZoom = !this.peekZoom;
        },  
        imageUrl(url) {
            return this.$imageServerUrl() +  url.replace('-front-', '-front!bgwh-');
            //return this.$imageServerUrl() +  url.replace('-front-', '-front!silbl!bgwh-');
            //return this.$imageServerUrl() +  url.replace('-front-', '-front!silbl!bgsg-');
            
            if (url.indexOf('https://') > -1)
                return url;
            else
                return 'https://s0.dessy.com' + url.replace('-front-', '-front!bgwh-');
        },
        peekUrl(url) {
            return 'http://static.dessy.com/services/cropproduct.ashx?crop=percent&lp=35&rp=35&bp=35&tp=42&url=' + url.replace(this.Item.ProductId, this.Item.PrimaryFabric.SwatchProductId).replace(this.Item.ProductId, this.Item.PrimaryFabric.SwatchProductId).replace('-big.', '-yawah.');
        },
        loadMain(url) {
            this.isMainLoaded = true;
        },
        loadPeek(url) {
            this.isPeekLoaded = true;
        }
    }, 
    mounted() {
        this.ActiveProductId = this.Item.ProductId;
    },
    data() {
        return { isMainLoaded: false, isPeekLoaded: false, peekZoom:false, ActiveProductId: -1 }

    }
    
}
</script>

<style scoped>
    .v-lazy-image { visibility:hidden }
    .v-lazy-image.v-lazy-image-loaded {visibility: visible;}
    .product-image img {width:100%}
    .clipCircle { clip-path: circle(60px at center); }
</style>

